import React, { Component } from 'react';
import Layout from "./Layout";
import { Button } from "~/js/partials";

export default class SuccessPopup extends Component {
    render() {
        const { successMsg, close, ...rest } = this.props;

        return (
            <Layout
                title={successMsg.title}
                text={successMsg.text}
                close={close}
                {...rest}
            >
                <Button
                    title={`Finish`}
                    modifiers={['solid', 'medium']}
                    chevron={true}
                    onClick={close}
                />
            </Layout>
        );
    }
}
